import {View} from "@khanacademy/wonder-blocks-core";

import strings from "#class-package/mastery-assignments/strings.ts";

import BaseToastNotification from "../components/base-toast-notification.tsx";

const MasteryGoalCreatedNotification = ({newGoals}) => {
    if (newGoals?.length > 0) {
        const assignment = newGoals[0]?.assignments?.[0];
        const studentCount = newGoals[0]?.studentKaids?.length;
        const classroomName = newGoals[0]?.classroomName;
        const isSingleClassroom = newGoals.length === 1;
        const isSingleAssignment = newGoals[0].assignments.length === 1;

        if (isSingleClassroom) {
            if (isSingleAssignment) {
                const message = strings.youHaveAssignedGoals(
                    assignment.title,
                    studentCount || 0,
                );
                return (
                    <BaseToastNotification>
                        {message} <strong>{classroomName}</strong>
                    </BaseToastNotification>
                );
            }

            const message = strings.youHaveAssignedMultipleGoals(
                newGoals[0]?.assignments?.length || 0,
                studentCount || 0,
            );
            return (
                <BaseToastNotification>
                    {message} <strong>{classroomName}</strong>
                </BaseToastNotification>
            );
        }
        const assignedMultipleGoals = newGoals[0]?.assignments?.length > 1;

        const MultipleClassroomAssignments = () => (
            <View>
                {assignedMultipleGoals
                    ? strings.youAssignedMultipleGoalsMultipleGoals(
                          newGoals[0]?.assignments?.length || 0,
                      )
                    : strings.youAssignedMultipleClassSingleGoal(
                          assignment?.title || "",
                      )}
                <ul>
                    {newGoals.map((classroom, index) => (
                        <li style={{listStyle: "disc inside"}} key={index}>
                            {strings.youAssignedMultipleGoalsMultipleStudents(
                                classroom.studentKaids?.length || 0,
                            )}{" "}
                            {classroom.classroomName}
                        </li>
                    ))}
                </ul>
            </View>
        );

        return (
            <BaseToastNotification>
                <MultipleClassroomAssignments />
            </BaseToastNotification>
        );
    }

    return null;
};

export default MasteryGoalCreatedNotification;
